module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/lucja-mysiorska-ceae77297c9d887ca90f32d86fe8264c.webp";